import { BaseFlowFormService } from '@/modules/core/form/services/BaseFlowFormService';
import { CheckoutSessionCart } from '@/modules/billing/models/CheckoutSessionCart';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { Route } from '@/modules/core/app/constants/api.constants';
import { Component } from 'vue';
import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';
import { Billing } from '@/modules/billing/models/Billing';
import Lang from '@/modules/core/app/services/Lang';
import { CheckoutSessionModalParams } from '@/modules/billing/services/CheckoutSessionModalParams';
import EventBus from '/@/modules/core/app/helpers/EventBus';
import { BillingEvent } from '/@/modules/billing/constants/BillingEvent';

export class CheckoutSessionFlowService extends BaseFlowFormService {
  constructor(
    public firstComponent: Component,
    public billingPlanId?: BillingPlanId,
    public text?: CheckoutSessionModalParams['text']
  ) {
    super();
  }

  getModel(): BaseModel {
    return CheckoutSessionCart;
  }

  getRoute(): string {
    return Route.BILLINGS_CREATECHECKOUTSESSION;
  }

  getFirstComponent(): Component {
    return this.firstComponent;
  }

  getSaveMessage(): string | null {
    return null;
  }

  getHeaderText(billing?: Billing): string {
    if (this.text?.header) {
      return this.text.header;
    }

    return billing?.isBasicPlan
      ? Lang.t('billing.confirm-plan-will')
      : Lang.t('billing.confirm-plan-will-to-access-will');
  }

  getSubheaderText(): string | undefined {
    return this.text?.subheader;
  }

  async onModalClose(): Promise<void> {
    EventBus.signal(BillingEvent.ON_PAYWALL_CLOSED);
  }
}
